module.exports = __webpack_public_path__ + "KG.png?c0059ac7e8aa487b60e729e06b0a8ebf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/KG.png
// module id = 368
// module chunks = 0